import * as React from "react";
const XStatIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={57}
    height={57}
    fill="none"
    {...props}
  >
    <path
      fill="#FFE0E0"
      d="M56.419 28.884c0-15.464-12.537-28-28-28-15.465 0-28 12.536-28 28s12.535 28 28 28c15.463 0 28-12.536 28-28Z"
    />
    <path
      fill="#FF4B41"
      d="M17.312 19.2a.5.5 0 1 1 .707-.708l20.785 20.785a.5.5 0 0 1-.707.707L17.312 19.199Z"
    />
    <path
      fill="#FF4B41"
      d="M18.863 40.095a.5.5 0 0 1-.715-.699L38.69 18.372a.5.5 0 0 1 .715.7L18.863 40.094Z"
    />
  </svg>
);
export default XStatIcon;
